import React from 'react';
import { List } from 'semantic-ui-react'
// import {graphql} from 'react-apollo';

//utils
// import queries from '../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';

//Rangos de facturación
const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.prefijo}</td>
      <td className=''>{elemento.factInicial}</td>
      <td className=''>{elemento.factFinal}</td>
      <td className=''>{elemento.proxFact}</td>
      <td className=''>{elemento.cicloFact}</td>
      <td className='' style={{color: elemento.estadoRangoFact?'yellow':'#93291E', fontWeight: 'bold'}}>{elemento.estadoRangoFact?'ACTIVO':'INACTIVO'}</td>
      <td className=''>{elemento.observaciones}</td>
    </tr>
  )
};

const Lista = ({styles, list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} styles={styles}
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const FactRFact2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a052001 = autorizacUA.findIndex( autorizac => autorizac === "052001" );

  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Rangos de facturación" btnNuevo={a052001!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '10%'}}>Prefijo</th>
                <th className='' style={{width: '10%'}}># inicial</th>
                <th className='' style={{width: '10%'}}># final</th>
                <th className='' style={{width: '10%'}}># última fact</th>
                <th className='' style={{width: '10%'}}># ciclo fact</th>
                <th className='' style={{width: '10%'}}>Estado</th>
                <th className='' style={{width: '40%'}}>Observaciones</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>
      </List> 
    </div>
  )
};

export default FactRFact2
